import {
  FormulationProcedure,
  FormulationTableProperties
} from 'types/Products';
import { getUniquePhases } from 'components/pages/products/editor/sections/formulations/FormulationTable/helper';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';

import { useStylesProductPageUXB } from '../SharedStyles/SharedStyles';

interface Props {
  formulation: {
    formulation: FormulationTableProperties[];
    procedure?: FormulationProcedure[];
  };
}
export const ConceptsTable: React.FC<Props> = ({ formulation }) => {
  const { classes } = useStylesProductPageUXB();

  const concepstsTableRows = formulation.formulation
    ? getUniquePhases(formulation.formulation)
        .map(phase =>
          formulation.formulation
            .filter(product => product.properties.phase === phase)
            .sort((a, b) => a.properties.order - b.properties.order)
        )
        .flat()
        .sort((a, b) =>
          (a?.properties?.phase ?? 'A').localeCompare(
            b?.properties?.phase ?? 'A'
          )
        )
        .map(product => ({
          phase: product.properties.phase,
          name: product.value,
          old_key: product.properties?.linked_product_detail?.old_key,
          inci: product.properties.inci?.join(', '),
          //filter out null values, probably just an issue on dev
          function: product.properties.functions
            ?.filter(inci => inci)
            .join(', '),
          weight: product.properties.weight
        }))
    : [];

  const hasConceptsProcedure =
    formulation.procedure && formulation.procedure.length > 0;

  return (
    <Box className={classes.productInformationGrid}>
      <Typography
        variant="h3"
        sx={{
          color: 'GrayText'
        }}
      >
        Concept{concepstsTableRows.length > 0 && ' table'}
        {concepstsTableRows.length > 0 && hasConceptsProcedure && ' and'}
        {hasConceptsProcedure && ' procedure'} {}
      </Typography>
      <div>
        {concepstsTableRows.length > 0 && (
          <Box sx={{ overflow: 'auto' }}>
            <Box sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}>
              <TableContainer>
                <Table sx={{ minWidth: 650 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Phase</TableCell>
                      <TableCell>Trade name</TableCell>
                      <TableCell>INCI</TableCell>
                      <TableCell>Function</TableCell>
                      <TableCell align="right">%w/w</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {concepstsTableRows.map(row => (
                      <TableRow
                        key={row.name}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 }
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.phase}
                        </TableCell>
                        <TableCell>{row.name}</TableCell>
                        <TableCell>{row.inci}</TableCell>
                        <TableCell>{row.function}</TableCell>
                        <TableCell align="right">{row.weight}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        )}
        {hasConceptsProcedure && formulation.procedure && (
          <Box sx={{ mt: 1 }}>
            <Typography
              variant="h4"
              sx={{
                color: 'GrayText',
                mb: 2
              }}
            >
              Procedure:
            </Typography>
            {formulation.procedure
              .sort((a, b) => a.properties.order - b.properties.order)
              .map((procedure, index) => (
                <Typography key={procedure.value} variant="body1">
                  {`${index + 1}. ${procedure.value}`}
                </Typography>
              ))}
          </Box>
        )}
      </div>
    </Box>
  );
};
